import { FadeUp, MaskReveal } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import { waTopic } from "@/data/site";

const NeuroIntro = () => (
  <section data-testid="neuro-intro-section" className="pt-28 lg:pt-40">
    <div className="container-x grid items-center gap-14 pb-20 lg:grid-cols-12 lg:pb-28">
      <div className="lg:col-span-7">
        <FadeUp>
          <p className="eyebrow" data-testid="neuro-intro-eyebrow">Neuropsicologia</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h1 className="mt-5 max-w-2xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-testid="neuro-intro-title">
            O que é <em className="italic text-raiz-700">Neuropsicologia?</em>
          </h1>
        </FadeUp>
        <FadeUp delay={0.16} className="mt-8 max-w-xl space-y-5">
          <p className="text-base leading-relaxed text-ink/70 md:text-lg">
            A Neuropsicologia é uma área da Psicologia que estuda a relação entre o funcionamento do cérebro, os processos cognitivos, as emoções e o comportamento.
          </p>
          <p className="text-base leading-relaxed text-ink/70">
            Na prática clínica, esse olhar contribui para compreender como a pessoa percebe informações, aprende, mantém a atenção, utiliza a memória, se organiza, resolve problemas e responde às diferentes demandas do cotidiano.
          </p>
        </FadeUp>
        <FadeUp delay={0.24} className="mt-9">
          <ArrowButton href={waTopic("a neuropsicologia")} target="_blank" rel="noopener noreferrer" testId="neuro-intro-cta">
            Conversar sobre Neuropsicologia
          </ArrowButton>
        </FadeUp>
      </div>
      <div className="relative lg:col-span-5">
        <div aria-hidden="true" className="absolute -bottom-6 -right-6 h-full w-full rounded-[2rem] bg-sand" />
        <MaskReveal className="relative overflow-hidden rounded-[2rem]">
          <img
            src="/assets/sabrina-neuro.jpg"
            alt="Sabrina Mota, neuropsicóloga, em seu consultório"
            data-testid="neuro-intro-photo"
            className="aspect-[4/5] w-full object-cover"
            width="1200"
            height="1500"
          />
        </MaskReveal>
      </div>
    </div>
  </section>
);

export default NeuroIntro;
